import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class SupportService {

  constructor(
    private http: HttpClient
  ) { }


  getPopup(tableName, id){
    let params : HttpParams = new HttpParams().set('tableName', tableName).set('id', id);
    return this.http.get<response>(environment.url+"popup", {params : params});
  }

  getCompanyDetails(){
    return this.http.get<response>(environment.url+"company");
  }

  updateCompanyDetails(company){
    return this.http.post<response>(environment.url+"company", company);
  }

  getNames(tableName){
    let params : HttpParams = new HttpParams().set('tableName', tableName);
    return this.http.get<response>(environment.url+"supports", {params : params});
  }

  getCategories(caseTypeId){
    let params : HttpParams = new HttpParams().set('caseTypeId', caseTypeId);
    return this.http.get<response>(environment.url+"supports/categories", {params : params});
  }

  getActivities(type, modelId, modelName){
    let params : HttpParams = new HttpParams().set('type', type).set('modelId', modelId).set('modelName', modelName);
    return this.http.get<response>(environment.url+"supports/activities", {params : params});
  }

  getName(tableId, tableName){
    let params : HttpParams = new HttpParams().set('tableId', tableId).set('tableName', tableName);
    return this.http.get<response>(environment.url + "support", {params : params});
  }

  saveName(tableName, value){
    let data = {
      'tableName' : tableName,
      'value' : value
    };
    return this.http.post<response>(environment.url+"support", data);
  }

  updateName(tableId, tableName, value){
    let data = {
      'tableName' : tableName,
      'value' : value
    };
    return this.http.put<response>(environment.url+"support/"+tableId, data);
  }

  deleteName(tableId, tableName){
    let params : HttpParams = new HttpParams().set('tableId', tableId).set('tableName', tableName);
    return this.http.delete<response>(environment.url + "support", {params : params});
  }

}
